import React from "react";
import { useSelector } from "react-redux";
import ComposedChart from "../../../../components/composedChart/composedChart";

export const BookingsBreakdownComposedChart = () => {
  const { metrics, data } = useSelector((state) => state.studioInfo.barChart);

  return (
    <ComposedChart
      chartData={{
        metrics,
        data,
        colors: ["#4667d4", "#2651ac", "#95adf7"]
      }}
    />
  );
};
